import React, { FunctionComponent } from 'react'
import { Icon } from '../styles'
import iconTransferenciaPorcentagem from '../../../assets/icons/pagamentos/icon-porcentagem-transferencia.svg'
import { IconsProp } from '../Icons.type'

const IconPorcentagemTransferencia: FunctionComponent<IconsProp> = ({
  size,
}) => <Icon src={iconTransferenciaPorcentagem} size={size} />
export default IconPorcentagemTransferencia
